import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserPlumbingGame from 'src/games/PlumbingGame/Main';

interface PlumbingGameProps extends PageProps<{}> {
    onComplete?: () => void;
}

class PlumbingGame extends React.Component<PlumbingGameProps> {
    constructor(props: PlumbingGameProps) {
        super(props);
        bindAllOfThis(this, PlumbingGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserPlumbingGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default PlumbingGame;



// WEBPACK FOOTER //
// ./src/pages/game/PlumbingGame.tsx